import { canauxConstants as can } from "../../../constants/canaux";

const initialState = { loading: true, list: [], data: null };

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case can.GET_CANAUX:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case can.GET_CANAL:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    default:
      return state;
  }
}
